import Crud from './crud'
var crud = new Crud('check-bigpackage', 'đối soát bao hàng');

const state = {
    ...crud.state,
    selected: {
        ID: 0,
        Status: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};